/*
JS for Slider Gallery flexible section
 */
import CustomSwiper from '../components/custom-swiper';

const domLoaded = (onLoaded) => {
	if (document.readyState !== 'loading') {
		// Document is already ready, call the callback directly
		onLoaded();
	} else if (document.addEventListener) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener('DOMContentLoaded', onLoaded);
	} else {
		// Old IE browsers
		document.attachEvent('onreadystatechange', function () {
			if (document.readyState === 'complete') {
				onLoaded();
			}
		});
	}
};

const App = {
	init() {
		const gallerySwiper = new CustomSwiper(
			'.view-also-swiper-container',
			{
				spaceBetween: 16,
				centeredSlides: false,
				slidesPerView: 1.08,
				loop: false,
				freeMode: true,
				breakpoints: {
					768: {
						slidesPerView: 1.8,
						spaceBetween:24
					},
					1024: {
						slidesPerView: 2.3,
						spaceBetween:24
					},
				},
				// on: {
				// 	transitionEnd: function () {
				// 		let slideIndex = Math.abs(Math.floor(this.translate / [swiperCardWidth]));
				// 		if (slideIndex !== 0) {
				// 			slideIndex = slideIndex - 1;
				// 		}
				// 	},
				// }
			},
		);
		gallerySwiper.init();

	}
};

domLoaded(() => {
	App.init();
});
